// Redux Actions for Analytics Profiles
export const SET_ANALYTICS_PROFILES = "SET_ANALYTICS_PROFILES";

export const setAnalyticsProfiles = (analyticsProfiles) => ({
  type: SET_ANALYTICS_PROFILES,
  payload: analyticsProfiles,
});

// Prefetch cache: { [scope]: { results, batchPayload, timestamp } }
export const SET_ANALYTICS_PREFETCH = "SET_ANALYTICS_PREFETCH";

export const setAnalyticsPrefetch = ({ scope, results, batchPayload }) => ({
  type: SET_ANALYTICS_PREFETCH,
  payload: { scope, results, batchPayload, timestamp: Date.now() },
});
